export default {"src":"/_next/static/media/white-scale.7f6493d4.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};